<!-- 线性图 -->
<template>
  <div id="map">暂无数据...</div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: ['mapData'],
  data() {
    /* eslint-disable */
    return {
      option: {
        color: ['#6E9CFA', '#FE5377', '#95FFEC', '#F86F91', '#5C8BFF', '#FCBE64', '#8BE0F0', '#9B81FB', '#FD765D', '#4AB664', '#F38AC3', '#AC71FF', '#F4E56E'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: []
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      }
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.flush()
  },
  methods: {
    refreshMap() {
      const myChart = echarts.init(document.getElementById('map'))
      myChart.setOption(this.option);
    },
    flush() {
      if (this.mapData) {
        this.option.xAxis.data = this.mapData.dataList
        const keyValue = Object.keys(this.mapData.all[0])[0]
        const dataY = this.mapData.all[0][keyValue]
        // console.log(dataY);
        this.option.series = dataY.map(item => {
          return {
            name: item.legend,
            type: 'line',
            data: item.value,
            smooth: true,
            showSymbol: false,
            emphasis: {
              focus: 'series'
            },
            areaStyle: {},
            stack: '总量'
          }
        })
        this.option.legend.data = dataY.map(v => v.legend)
        this.refreshMap()
      }
    }
  },
  watch: {
    mapData() {
      this.flush()
    }
  }
}
</script>
<style  scoped>
/* @import url(); 引入css类 */
#map {
  width: 100%;
  min-height: 430px;
}
</style>
